/**
 * Email document default colors (hex for rendered HTML).
 * Values align with src/public/scss/_variables.scss where noted.
 */

/** $gray900 */
export const EMAIL_BUILDER_COLOR_HEADING = "#101828";

/** $gray500 */
export const EMAIL_BUILDER_COLOR_GRAY_500 = "#667085";

/** $blue600 */
export const EMAIL_BUILDER_COLOR_BLUE_600 = "#2D4675";

export const EMAIL_BUILDER_COLOR_BUTTON_TEXT = "#FFFFFF";

/** Neutral line color: dividers, eyebrow rules, band borders, stack-divider fallback. */
export const EMAIL_BUILDER_COLOR_DIVIDER = "#E4E7EC";

/** Brand button border gold (no exact SCSS token; nearest $primaryYellow #C4B151) */
export const EMAIL_BUILDER_COLOR_BUTTON_BORDER = "#CCA152";

export const EMAIL_BUILDER_COLOR_BACKGROUND = "#FFFFFF";

/** Outer page area behind the 600px content column. */
export const EMAIL_BUILDER_COLOR_PAGE_BACKGROUND = "#F2F4F7";
